import React from 'react';
import TextComponent from './TextComponent';
import LinkComponent from './LinkComponent';
import SocialLinksComponent from './SocialLinksComponent';
import VideoComponent from './VideoComponent';
import AudioComponent from './AudioComponent';
import ImageComponent from './ImageComponent';
import DonationComponent from './DonationComponent';
import MintNFTComponent from './MintNFTComponent';
import HtmlComponent from './HtmlComponent';
import AdComponent from './AdComponent';

export function renderPublicMuultiComponent({ comp, muulti, commonProps: providedCommonProps = null }) {
    if (!comp || !muulti) return null;

    const commonProps = providedCommonProps || {
        comp,
        style: comp.style || {},
        pageTypography: muulti.typography || null,
        isEditor: false,
        ownerPublicKey: muulti.publicKey || '',
        ownerUsername: muulti.muultiName || '',
    };

    switch (comp.type) {
        case 'text':
            return <TextComponent {...commonProps} />;
        case 'mint':
            return (
                <MintNFTComponent
                    {...commonProps}
                    comp={comp}
                    style={comp.style || {}}
                />
            );
        case 'donation': {
            const donationComp = {
                ...comp,
                recipientPublicKey: comp.recipientPublicKey || muulti.publicKey || '',
            };
            return (
                <DonationComponent
                    {...commonProps}
                    comp={donationComp}
                    style={donationComp.style || {}}
                    pageTypography={muulti.typography || null}
                />
            );
        }
        case 'link':
            return <LinkComponent {...commonProps} />;
        case 'social':
            return <SocialLinksComponent {...commonProps} />;
        case 'image':
            return <ImageComponent {...commonProps} />;
        case 'video':
            return <VideoComponent {...commonProps} />;
        case 'html':
            return <HtmlComponent {...commonProps} />;
        case 'audio':
            return <AudioComponent {...commonProps} />;
        case 'ad':
            return <AdComponent {...commonProps} />;
        default:
            return null;
    }
}
